import { Typography } from '@mui/material';

export const HomePage: React.FC = () => {
  return (
    <div className="container">
      <Typography>
        Pick a tab from the navigation bar on left to start
      </Typography>
    </div>
  );
};
